import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-wallet-parent',
    templateUrl: './wallet-parent.component.html',
    styleUrls: ['./wallet-parent.component.scss'],
    standalone: false
})
export class WalletParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
